import React, { memo } from 'react'
import { EINForm } from 'src/components/ein/EINForm'

const EINComponent = () => {
  return <EINForm />
}

export const EIN = memo(EINComponent)
